// extracted by mini-css-extract-plugin
module.exports = {"cover":"FooterBlock_cover__2ZGnW","cop":"FooterBlock_cop__RAi_A"};